import IconButton from "@material-ui/core/IconButton";
import BuildIcon from "@material-ui/icons/Build";
import { Menu, MenuItem } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import React from "react";
import withIntl from "../../../utils/withIntl";
import NewArticleDialog from "../Articles/NewArticleDialog";
import articlesStore from "../../../store/articles/ArticlesStore";
import { updateArticles } from "../../../store/articles/ArticlesApi";
import { useDialog } from "../../Dialogs/DialogProvider";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import AuthorizationWrapper from "../../AuthorizationWrapper";
import EditIcon from "@material-ui/icons/Edit";
import ArticlegroupDetailsDialog from "../Articles/ArticlegroupDetailsDialog";

function ActionButtonArticlegroup(props) {
  const [openDialog] = useDialog();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleOpenNewArticleDialog = (event) => {
    event.stopPropagation();
    openDialog({
      children: <NewArticleDialog articlegroup={props.articlegroup} fullWidth={true} />,
      fullWidth: true,
      maxWidth: "md",
      disableBackdropClick: true,
    });
  };

  const handleBatchUpdateArticles = (value) => {
    const allArticlesInGroup = Object.keys(articlesStore.articles)
      .map((key) => articlesStore.articles[key])
      .filter((article) => article.articlegroup_id === props.articlegroup.id);
    let newData = [];
    allArticlesInGroup.forEach((article) => {
      newData.push({ manual_active: value });
    });

    updateArticles(articlesStore.merchantId, allArticlesInGroup, newData);
  };

  const handleOpenArticlegroupDetailsDialog = () => {
    openDialog({
      children: <ArticlegroupDetailsDialog articlegroup={props.articlegroup} currentLanguage={props.currentLanguage} />,
      fullWidth: true,
      maxWidth: "sm",
    });
  };

  return (
    <div>
      <IconButton
        onClick={(event) => {
          if (isNaN(props.articlegroup.id)) {
            alert(props.intl.formatMessage({ id: "create_articles_to_save_changes_first" }));
          }
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
        variant="standard"
      >
        <BuildIcon colo={"primary"} />
      </IconButton>
      <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem
          onClick={(event) => {
            if (isNaN(props.articlegroup.id)) {
              alert(props.intl.formatMessage({ id: "create_articles_to_save_changes_first" }));
            } else {
              event.stopPropagation();
              handleOpenArticlegroupDetailsDialog();
              setAnchorEl(null);
            }
          }}
        >
          <EditIcon color="primary" />
          {props.intl.formatMessage({ id: "edit_articlegroup" })}
        </MenuItem>
        <AuthorizationWrapper
          permission={"add_new_article"}
          child={
            <MenuItem
              onClick={(event) => {
                event.stopPropagation();
                handleOpenNewArticleDialog(event);
                setAnchorEl(null);
              }}
            >
              <AddIcon color={"primary"} />
              {props.intl.formatMessage({ id: "add_article" })}
            </MenuItem>
          }
        />

        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            handleBatchUpdateArticles(true);
            setAnchorEl(null);
          }}
        >
          <ArrowRightIcon color={"primary"} />
          {props.intl.formatMessage({ id: "all_manual_active_on" })}
        </MenuItem>
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            handleBatchUpdateArticles(false);
            setAnchorEl(null);
          }}
        >
          <ArrowLeftIcon color={"primary"} />
          {props.intl.formatMessage({ id: "all_manual_active_off" })}
        </MenuItem>
      </Menu>
    </div>
  );
}

export default withIntl(ActionButtonArticlegroup);
